import React, { useState, useEffect } from "react";
import { FaCoins, FaCheckCircle, FaTimes, FaShieldAlt, FaArrowRight } from "react-icons/fa";
import Navbar from "../components/Navbar";
import Breadcrumb from "./BreadCrumb";
import logo from "../assets/logo.png";

const BASE_URL = "https://api.dreamtoday.in";

const Packages = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [paymentProcessing, setPaymentProcessing] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [walletBalance, setWalletBalance] = useState(null);
  const [selectedPkg, setSelectedPkg] = useState(null);

  // Fetch plans
  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const res = await fetch(`${BASE_URL}/api/admin/getallplans`);
        const data = await res.json();
        if (data.success) {
          setPackages(data.plans.filter((p) => p.status === "active"));
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchPlans();
  }, []);

  const openRazorpay = () => {
    const userId = sessionStorage.getItem("userId");
    if (!userId) {
      alert("Please login first");
      return;
    }

    const plan = selectedPkg;
    setSelectedPkg(null);

    const options = {
      key: "rzp_live_SXqgtV4FlXYmGP",
      amount: Math.round(plan.price * 100),
      currency: "INR",
      image: logo,
      name: "Dream Today",
      description: `${plan.coins} Coin Package`,
      theme: { color: "#f59e0b" },

      handler: async function (response) {
        setPaymentProcessing(true);
        try {
          const res = await fetch(
            `${BASE_URL}/api/users/purchaseplan/${userId}`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                planId: plan._id,
                transactionId: response.razorpay_payment_id,
              }),
            }
          );
          const data = await res.json();
          if (data.success) {
            setWalletBalance(data.walletBalance);
            setTimeout(() => {
              setPaymentProcessing(false);
              setSuccessModal(true);
            }, 1200);
          }
        } catch (err) {
          console.error(err);
          setPaymentProcessing(false);
        }
      },

      prefill: {
        name: "Dream Today User",
        email: "dreamtoday@gmail.com",
      },
    };

    const razor = new window.Razorpay(options);
    razor.open();
  };

  return (
    <>
      <Navbar />

      <div className="min-h-screen bg-gradient-to-br from-amber-50 via-yellow-50 to-amber-100 pt-28 pb-16 px-4 sm:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="mb-6">
            <Breadcrumb
              items={[
                { label: "My Account", path: "/myaccount" },
                { label: "Wallet", path: "/wallet" },
                { label: "Packages" },
              ]}
            />
          </div>

          <h1 className="text-3xl font-bold mb-10 text-yellow-800">
            Buy Coin Packages
          </h1>

          {loading ? (
            <div className="flex justify-center py-20">
              <div className="w-10 h-10 border-4 border-yellow-400 border-t-transparent rounded-full animate-spin" />
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {packages.map((pkg, index) => {
                const isPopular = index === 1;
                return (
                  <div
                    key={pkg._id}
                    className={`relative bg-white border border-yellow-200 rounded-3xl p-8 shadow-lg hover:shadow-2xl transition ${
                      isPopular ? "ring-2 ring-yellow-400 scale-[1.02]" : ""
                    }`}
                  >
                    {isPopular && (
                      <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-yellow-500 text-white text-xs px-4 py-1 rounded-full">
                        Most Popular
                      </div>
                    )}
                    <div className="flex justify-center mb-4">
                      <FaCoins className="text-yellow-500 text-4xl" />
                    </div>
                    <h2 className="text-2xl font-bold text-yellow-700 text-center">
                      {pkg.coins} Coins
                    </h2>
                    <p className="text-green-600 font-semibold text-center mt-1">
                      + {pkg.bonusCoins} Bonus Coins
                    </p>
                    <p className="text-xl font-semibold text-amber-800 text-center my-4">
                      ₹ {pkg.price}
                    </p>
                    <ul className="space-y-2 mb-6">
                      {pkg.features.map((feature, i) => (
                        <li
                          key={i}
                          className="flex items-center gap-2 text-sm text-gray-700 font-semibold"
                        >
                          <FaCheckCircle className="text-green-500 text-xs" />
                          {feature}
                        </li>
                      ))}
                    </ul>
                    <button
                      onClick={() => setSelectedPkg(pkg)}
                      className="w-full py-3 rounded-xl bg-gradient-to-r from-yellow-500 to-amber-600 text-white font-semibold hover:scale-105 transition"
                    >
                      Buy Now
                    </button>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {/* ── CONFIRMATION MODAL ── */}
      {selectedPkg && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 px-4">
          <div className="bg-white rounded-3xl shadow-2xl w-full max-w-md overflow-hidden animate-[fadeInUp_0.25s_ease]">

            {/* Header */}
            <div className="bg-gradient-to-r from-yellow-500 to-amber-600 px-6 py-5 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="bg-white/20 rounded-full p-2">
                  <FaCoins className="text-white text-xl" />
                </div>
                <div>
                  <p className="text-white/80 text-xs font-medium uppercase tracking-wider">
                    Order Summary
                  </p>
                  <h3 className="text-white text-lg font-bold leading-tight">
                    {selectedPkg.coins} Coins Package
                  </h3>
                </div>
              </div>
              <button
                onClick={() => setSelectedPkg(null)}
                className="text-white/70 hover:text-white transition p-1"
              >
                <FaTimes className="text-lg" />
              </button>
            </div>

            {/* Coin summary pill */}
            <div className="mx-6 -mt-4 bg-amber-50 border border-yellow-200 rounded-2xl px-5 py-3 flex items-center justify-between shadow-sm">
              <div>
                <p className="text-xs text-gray-500 font-medium">You receive</p>
                <p className="text-yellow-700 font-bold text-lg">
                  {selectedPkg.coins + selectedPkg.bonusCoins}{" "}
                  <span className="text-sm font-semibold">Total Coins</span>
                </p>
              </div>
              <div className="text-right">
                <p className="text-xs text-green-600 font-medium">
                  🎁 {selectedPkg.bonusCoins} bonus included
                </p>
              </div>
            </div>

            {/* Price breakdown */}
            <div className="px-6 pt-5 pb-4 space-y-3">
              <h4 className="text-xs font-semibold text-gray-400 uppercase tracking-widest mb-1">
                Price Breakdown
              </h4>

              <div className="flex justify-between text-sm text-gray-600">
                <span>Package Price</span>
                <span className="font-semibold text-gray-800">
                  ₹ {selectedPkg.price.toFixed(2)}
                </span>
              </div>

              <div className="border-t border-dashed border-yellow-200 pt-3 flex justify-between items-center">
                <span className="font-bold text-gray-800 text-base">
                  Total Payable
                </span>
                <span className="text-xl font-bold text-amber-600">
                  ₹ {selectedPkg.price.toFixed(2)}
                </span>
              </div>
            </div>

            {/* Secured note */}
            <p className="text-center text-xs text-gray-400 pb-2 flex items-center justify-center gap-1">
              <FaShieldAlt className="text-green-400" />
              Secured payment powered by Razorpay
            </p>

            {/* Actions */}
            <div className="px-6 pb-6 flex gap-3">
              <button
                onClick={() => setSelectedPkg(null)}
                className="flex-1 py-3 rounded-xl border border-gray-200 text-gray-500 font-semibold text-sm hover:bg-gray-50 transition"
              >
                Cancel
              </button>
              <button
                onClick={openRazorpay}
                className="flex-1 py-3 rounded-xl bg-gradient-to-r from-yellow-500 to-amber-600 text-white font-bold text-sm flex items-center justify-center gap-2 hover:opacity-90 hover:scale-[1.02] transition"
              >
                Proceed to Pay
                <FaArrowRight className="text-xs" />
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── PAYMENT PROCESSING MODAL ── */}
      {paymentProcessing && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl p-8 text-center shadow-xl w-[320px]">
            <div className="flex justify-center mb-4">
              <div className="w-12 h-12 border-4 border-yellow-400 border-t-transparent rounded-full animate-spin" />
            </div>
            <h3 className="text-lg font-semibold text-gray-800">
              Processing Payment
            </h3>
            <p className="text-sm text-gray-500 mt-2">
              Please wait while we confirm your transaction...
            </p>
          </div>
        </div>
      )}

      {/* ── SUCCESS MODAL ── */}
      {successModal && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl p-8 max-w-sm w-full text-center shadow-xl">
            <div className="text-green-500 text-5xl mb-4 flex justify-center">
              <FaCheckCircle />
            </div>
            <h2 className="text-xl font-bold mb-2 text-yellow-700">
              Payment Successful
            </h2>
            <p className="text-gray-600 mb-4">Coins added successfully!</p>
            <p className="font-semibold text-yellow-700">
              Wallet Balance: {walletBalance} Coins
            </p>
            <button
              onClick={() => setSuccessModal(false)}
              className="mt-6 px-6 py-2 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Packages;